"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FirebaseAPI = require("./firebase/FirebaseAPI");
Object.keys(_FirebaseAPI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FirebaseAPI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FirebaseAPI[key];
    }
  });
});
// let {BaseFirebaseDB} = require('../lib/index.js')
// module.exports.BaseFirebaseDB = require('./firebase/BaseFirebaseDB')
//
// module.exports.FirebaseAPI = require('./firebase/FirebaseAPI')
// module.exports.FirestoreDB = require('./firebase/FirestoreDB')
// module.exports.RealtimeDB = require('./firebase/RealtimeDB')
// module.exports.FirebaseStorageClient = require('./firebase/FirebaseStorageClient')
// module.exports.FirebaseStorageAdmin = require('./firebase/FirebaseStorageAdmin')
//
// module.exports.FirestorePager = require('./filters/FirestorePager')
// module.exports.DataFilter = require('./filters/DataFilter')
// module.exports.SearchKeywordsFilter = require('./filters/SearchKeywordsFilter')
// module.exports.FilterOptions = require('./filters/FilterOptions')
// module.exports.SortOptions = require('./filters/SortOptions')

// export * from './firebase/BaseFirebaseDB.js'

// export * from './firebase/FirestoreDB'
// export * from './firebase/RealtimeDB'
// export * from './firebase/FirebaseStorageClient'
// export * from './firebase/FirebaseStorageAdmin'
//
// export * from './filters/FirestorePager'
// export * from './filters/DataFilter'
// export * from './filters/SearchKeywordsFilter'
// export * from './filters/FilterOptions'
// export * from './filters/SortOptions'
module.exports.BaseFirebaseDB = require('./firebase/BaseFirebaseDB');
module.exports.FirebaseAPI = require('./firebase/FirebaseAPI');
module.exports.FirestoreDB = require('./firebase/FirestoreDB');
module.exports.RealtimeDB = require('./firebase/RealtimeDB');
module.exports.FirebaseStorageClient = require('./firebase/FirebaseStorageClient');
module.exports.FirebaseStorageAdmin = require('./firebase/FirebaseStorageAdmin');
module.exports.FirestorePager = require('./filters/FirestorePager');
module.exports.DataFilter = require('./filters/DataFilter');
module.exports.SearchKeywordsFilter = require('./filters/SearchKeywordsFilter');
module.exports.FilterOptions = require('./filters/FilterOptions');
module.exports.SortOptions = require('./filters/SortOptions');